import { render, staticRenderFns } from "./GroupDetailTalk.vue?vue&type=template&id=33d06fa7&scoped=true"
import script from "./GroupDetailTalk.vue?vue&type=script&lang=js"
export * from "./GroupDetailTalk.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailTalk.vue?vue&type=style&index=0&id=33d06fa7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d06fa7",
  null
  
)

export default component.exports